import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RoundQuantityPickerWrapper } from "@faire/retailer-visitor-shared/components/QuickAdd/EncapsulatedQuickAdd";
import { getValidImageOrPlaceholder } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/getValidImageOrPlaceholder";
import { TileImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/TileImage";
import { useValidateImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/useValidateImage";
import { isFastly } from "@faire/web--source/common/images/optimizeImages";
import { useRenderTracing } from "@faire/web--source/common/tracing/useRenderTracing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var ProductTileImage = function(props) {
    var _props_image, _props_productLinkProps, _props_productLinkProps1;
    var endTrace = useRenderTracing("ProductTileImage", {
        productToken: props.productToken
    });
    var primaryImage = props.image;
    var validImage = useValidateImage(props.image);
    if (((_props_image = props.image) === null || _props_image === void 0 ? void 0 : _props_image.url) && !isFastly(props.image.url)) {
        primaryImage = getValidImageOrPlaceholder(validImage);
    }
    var _primaryImage_alt_text;
    var altText = (_primaryImage_alt_text = primaryImage.alt_text) !== null && _primaryImage_alt_text !== void 0 ? _primaryImage_alt_text : props.imageAltText;
    var _props_productLinkProps_productUrl;
    return /*#__PURE__*/ _jsx(Link, {
        onClick: props.onClick,
        "data-test-id": props["data-test-id"],
        to: (_props_productLinkProps_productUrl = (_props_productLinkProps = props.productLinkProps) === null || _props_productLinkProps === void 0 ? void 0 : _props_productLinkProps.productUrl) !== null && _props_productLinkProps_productUrl !== void 0 ? _props_productLinkProps_productUrl : "",
        replace: (_props_productLinkProps1 = props.productLinkProps) === null || _props_productLinkProps1 === void 0 ? void 0 : _props_productLinkProps1.replace,
        children: /*#__PURE__*/ _jsxs(ImageContainer, {
            children: [
                /*#__PURE__*/ _jsx(TileImage, {
                    image: primaryImage,
                    showVerticalImagery: props.showVerticalImagery,
                    imageDimension: props.imageDimension,
                    imageContainerRef: props.imageContainerRef,
                    imageAltText: altText,
                    imageBreakpoints: props.imageBreakpoints,
                    onLoad: endTrace
                }),
                props.children
            ]
        })
    });
};
var ImageContainer = styled.div.withConfig({
    componentId: "sc-376fd0a0-0"
})([
    "width:100%;position:relative;display:block;&:hover{",
    "{",
    "{transition:opacity 100ms ease-in-out;opacity:1;}}}"
], responsiveMediaQueries.canHover, RoundQuantityPickerWrapper);
